"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _setDisplayName = _interopRequireDefault(require("./setDisplayName"));

var _wrapDisplayName = _interopRequireDefault(require("./wrapDisplayName"));

var identity = function identity(Component) {
  return Component;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var Branch = function Branch(props) {
      if (test(props)) {
        return /*#__PURE__*/(0, _react.createElement)(left(BaseComponent), props);
      }

      return /*#__PURE__*/(0, _react.createElement)(right(BaseComponent), props);
    };

    if (process.env.NODE_ENV !== 'production') {
      return (0, _setDisplayName["default"])((0, _wrapDisplayName["default"])(BaseComponent, 'branch'))(Branch);
    }

    return Branch;
  };
};

var _default = branch;
exports["default"] = _default;